'use es6';

import UISortableListComponent from 'ui-addon-draggable/components/UISortableList';
import UIDragList from 'ui-addon-draggable/list/UIDragList';
import connectDnd from 'ui-addon-draggable/decorators/connectDnd';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectedUISortableList = connectDnd(UISortableListComponent);
const UISortableList = props => /*#__PURE__*/_jsx(ConnectedUISortableList, Object.assign({}, props, {
  DragList: UIDragList
}));
UISortableList.propTypes = Object.assign({}, UISortableListComponent.propTypes);
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UISortableList.defaultProps = Object.assign({}, UISortableListComponent.defaultProps);
export default UISortableList;